import { useAtom } from "jotai";
import { MembersAtom, MembersIncreaseAtom, YearsAtom } from "./atoms";
import { useCallback } from "react";
import { mapRange } from "./mapRange";

export function useGetMemberCount() {
  const [initialMembers] = useAtom(MembersAtom);
  const [deltaMembers] = useAtom(MembersIncreaseAtom);
  return useCallback(
    (currentYear: number) => {
        return initialMembers * Math.pow(1 + deltaMembers, currentYear);
    },
    [deltaMembers, initialMembers]
  );
}
